module.exports = __webpack_public_path__ + "media/feature-icons/image-f5a0d300.png";